import React, { Component } from "react";
import { Fetch } from "../../utils/fetch";
import Navbar from "../../components/newNavBar";
import "./resources.scss";
import { Table, ConfigProvider } from "antd";
import Loader from "../../utils/loader";
import MobileMainHeader from "../../components/headers/mobileMainHeader";
import { MenuSlideDrawer } from "../../components/slideDrawer/SlideDrawer";
import SideMenu from "../../components/Layout/SideMenu";
import { operatorType } from "../../config";
import moment from "moment";
import mixpanel from "mixpanel-browser";

import pdfOne from "../../docs/Zingbus Operational Expectations.pdf";
import pdfTwo from "../../docs/Zingbus Service Quality Adherence Framework.pdf";
import { mixPanelToken, isStage, businessModelType } from "../../config";
import jwt from "../../utils/jwt";

class Resources extends Component {
  state = {
    loading: true,
    showSideMenu: false,
  };

  async componentDidMount() {
    try {
      const token = localStorage.getItem("idToken");

      const columns = [
        {
          title: "Name",
          dataIndex: "Name",
          align: "left",
        },
        {
          title: "Download",
          dataIndex: "documents",
          align: "center",
        },
      ];

      const tableData = [
        {
          key: "1",
          Name: (
            <span className="tableText">
              Zingbus Operational Expectations.pdf
            </span>
          ),
          documents: (
            <a
              onClick={() => this.downloadAnalytics()}
              className="download-button"
              href={pdfOne}
              download="Zingbus Operational Expectations.pdf"
            >
              Download
            </a>
          ),
        },
        {
          key: "2",
          Name: (
            <span className="tableText">
              Zingbus Service Quality Adherence Framework.pdf
            </span>
          ),
          documents: (
            <a
              onClick={() => this.downloadAnalytics()}
              className="download-button"
              href={pdfTwo}
              download="Zingbus Service Quality Adherence Framework.pdf"
            >
              Download
            </a>
          ),
        },
      ];

      const regex =
        /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      const isMobile = regex.test(navigator.userAgent);
      const decodedToken = jwt.decode(token);
      let userType = decodedToken.userType || "OPERATOR";
      if (sessionStorage.getItem("userType")) {
        userType = sessionStorage.getItem("userType");
      } else if (decodedToken && decodedToken.isElectricUser) {
        userType = "ELECTRIC";
      }
      const mobileNo = decodedToken.mobileNo;
      this.setState({
        tableData,
        userType,
        mobileNo,
        loading: false,
        isMobile,
        columns,
      });
    } catch (err) {
      console.log(err);
    }
  }

  fetchAgreement = async () => {
    const url = `/user/agreement`;
    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      const data = response.map((item) => ({
        key: item._id,
        name: item.name,
        time: moment(item.operatorEsignDetails.signedOn).format("DD-MMM-YY"),
        download: {
          download: () => this.downloadDoc(item._id),
        },
      }));
      return data;
    }
    // message.error("Something went wrong");
    return [];
  };

  downloadAnalytics = () => {
    const { userType, mobileNo, showMorebusRc } = this.state;
    const business_model_type = businessModelType.find(
      (opt) => opt.value === userType
    )?.label;
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Resource Downloaded", {
      view_from: "Resources Page",
      type: userType,
      mobile_number: mobileNo,
      business_model_type,
    });
  };

  fetchProfile = async (mobileNo, userType) => {
    let url = `/user/details?mobileNo=${mobileNo}`;
    if (userType === operatorType.CABOWNER) {
      url = `/mg/user/details?mobileNo=${mobileNo}`;
    }
    const options = {
      method: "get",
    };

    const response = await Fetch(url, options);

    if (Array.isArray(response) && response.length > 0) {
      return response[0];
    }
    return;
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  toggleSideMenu = () => {
    const { showSideMenu } = this.state;
    this.setState({
      showSideMenu: !showSideMenu,
    });
  };

  handleFileChange = (event) => {
    const file = event.target.files[0];
    this.setState({
      fileName: file ? file.name : "Choose a file",
      selectedFile: event.target.files[0],
    });
  };

  render() {
    const { columns, tableData, isMobile, loading, showSideMenu } = this.state;

    let active = 7;

    if (loading) {
      return (
        <div className="loader">
          <Loader />
        </div>
      );
    } else if (isMobile) {
      return (
        <div class="container">
          <MobileMainHeader toggleSideMenu={this.toggleSideMenu} />

          {showSideMenu ? (
            <MenuSlideDrawer
              toggleSideMenu={this.toggleSideMenu}
              showSideMenu={showSideMenu}
              isMobile={isMobile}
            >
              <SideMenu
                active={active}
                toggleSideMenu={this.toggleSideMenu}
                isMobile={isMobile}
              />
            </MenuSlideDrawer>
          ) : null}

          <div className="resources-headers">
            <span className="user">Resources</span>
            <span className="subUser">
              Explore resources available for download
            </span>
          </div>
          <div style={{ padding: "8px 16px" }}>
            <ConfigProvider
              theme={{
                token: {
                  colorPrimary: "#7b2ff",
                },
                components: {
                  Table: {
                    headerBg: "#454545", // Black background
                    headerColor: "#ffffff", // White text
                    headerBorderRadius: "12px",
                  },
                },
              }}
            >
              <Table
                columns={columns}
                dataSource={tableData}
                pagination={false}
              />
            </ConfigProvider>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Navbar isMobile={isMobile} selectedKey={17} />
          <div className="container-details">
            <div className="resources-headers">
              <span className="user">Resources</span>
              <span className="subUser">
                Explore resources available for download
              </span>
            </div>
            <div style={{ padding: "16px" }}>
              <ConfigProvider
                theme={{
                  token: {
                    colorPrimary: "#7b2ff",
                  },
                  components: {
                    Table: {
                      headerBg: "#454545", // Black background
                      headerColor: "#ffffff", // White text
                      headerBorderRadius: "12px",
                    },
                  },
                }}
              >
                <Table
                  columns={columns}
                  dataSource={tableData}
                  pagination={false}
                />
              </ConfigProvider>
            </div>
          </div>
        </div>
      );
    }
  }
}

export default Resources;
